interface TimeSaleHeaderProps {
  isTimeSaling: boolean;
  timeLeft: string | null;
  isTooltipOpen: boolean;
  onTooltipToggle: () => void;
}

const TimeSaleHeader = ({
  isTimeSaling,
  timeLeft,
  isTooltipOpen,
  onTooltipToggle,
}: TimeSaleHeaderProps) => (
  <div className="w-full px-5 pt-6 pb-4 relative">
    <h2 className="text-xl font-bold text-black flex items-center">
      {isTimeSaling ? "바로픽업 가능⚡" : "바로픽업⚡"}
      <button
        onClick={onTooltipToggle}
        className="ml-1 text-gray-400 hover:text-gray-600 focus:outline-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
      </button>
      {isTimeSaling && timeLeft && (
        <span className="ml-2 flex items-center bg-[#1569fc] rounded-lg px-2 py-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            className="mr-1"
          >
            <path
              d="M5.5 3.5V5.5L7 7M10 5.5C10 6.09095 9.8836 6.67611 9.65746 7.22208C9.43131 7.76804 9.09984 8.26412 8.68198 8.68198C8.26412 9.09984 7.76804 9.43131 7.22208 9.65746C6.67611 9.8836 6.09095 10 5.5 10C4.90905 10 4.32389 9.8836 3.77792 9.65746C3.23196 9.43131 2.73588 9.09984 2.31802 8.68198C1.90016 8.26412 1.56869 7.76804 1.34254 7.22208C1.1164 6.67611 1 6.09095 1 5.5C1 4.30653 1.47411 3.16193 2.31802 2.31802C3.16193 1.47411 4.30653 1 5.5 1C6.69347 1 7.83807 1.47411 8.68198 2.31802C9.52589 3.16193 10 4.30653 10 5.5Z"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-white text-xs font-semibold">{timeLeft}</span>
        </span>
      )}
    </h2>

    {isTooltipOpen && (
      <>
        <div
          className="fixed inset-0 z-10"
          onClick={() => onTooltipToggle()}
          aria-hidden
        />
        <div className="absolute left-5 top-14 z-20 w-[280px] bg-[#333333] text-white text-xs p-3 rounded-lg shadow-lg">
          <div className="absolute top-[-4px] left-[70px] w-2 h-2 bg-[#333333] rotate-45" />
          매장에서 실시간으로 진행하는 깜짝 타임세일 파트로 할인하는 상품을
          기다리지 않고 바로 픽업할 수 있는 서비스예요!
        </div>
      </>
    )}
  </div>
);

export default TimeSaleHeader;
